module.exports = __webpack_public_path__ + "static/ville1-2c12cd1de3af00a6c4c0d2537cfec369.jpg";